<template>
  <div>
    <custom-actions show-back :title="type === 'jr' ? '金融保证金充值退还' : '保证金充值退还'">
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="客户名称" prop="userId">
          <el-select filterable clearable v-model="form.userId" placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="流水凭证单号" prop="depositNumber">
          <el-input v-model="form.depositNumber" placeholder="请输入流水凭证单号"></el-input>
        </el-form-item>

        <el-form-item label="保证金类型" prop="depositType">
          <el-select v-model="form.depositType" filterable>
            <el-option :value="item.value" :label="item.label" v-for="(item, index) of typeList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="depositChange">
          <el-input-number v-model="form.depositChange" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="附件" prop="fileList">
          <file-upload v-model="form.fileList"></file-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
    <!-- <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer> -->

  </div>
</template>

<script>
export default {
  name: 'BondRecordAdd',
  data() {
    return {
      typeList: [
        {
          label: '充值',
          value: '1'
        },
        {
          label: '退还',
          value: '2'
        },
        {
          label: '转货款',
          value: '3'
        }
      ],

      form: {
        userId: '',
        depositNumber: '',
        depositType: '',
        depositChange: '',
        fileList: []

      },
      rules: {
        depositChange: [{ required: true, message: '请输入金额', trigger: ['change', 'blur'] }],
        depositNumber: [{ required: true, message: '请输入流水凭证单号', trigger: ['change', 'blur'] }],
        fileList: [{ required: false, message: '请上传附件', trigger: ['change', 'blur'] }],

        userId: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        depositType: [{ required: true, message: '请选择客户保证金类型', trigger: 'change' }]

      },
      userList: []
    }
  },
  computed: {
    depositId() {
      return this.$route.query.depositId
    },
    type() {
      return this.$route.query.type
    }
  },
  created() {
    this.loadType()
    this.loadUser()
    if (this.type === 'jr') {
      this.typeList = this.typeList.filter(item => item.value !== '3')
    }

    if (this.depositId) {
      this.loadDetails()
    }
  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '3'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadType() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'ygUnit' }
      }).then(res => {
        this.unitList = res.ygUnit || []
      })
    },
    loadDetails() {

    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.bondRecord.insertYxUserDepositRecord
        if (this.type === 'jr') {
          url = this.$apis.bondRecord.insertYxUserJrRecord
        }

        this.$axios.post(url, this.form).then(res => {
          this.$router.back()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 400px;
}
</style>
